import React from 'react'
import { type PricingProduct, type PricingFeature } from '../types/pricing.types'

import { useTranslation } from 'react-i18next'

import styles from '../styles/product-box.module.css'

type Props = {
    product: PricingProduct,
    selected?: boolean,
    fullSizedBox?: boolean,
    onClick: Function,
    isAlt: boolean
}

export default function ProductBox({product, selected=false, fullSizedBox=false, onClick, isAlt=false}: Props) {
    const {t} = useTranslation('pricing-tool');
    const keyPrefix = `products.${product.slug}.`;

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const family = event.currentTarget.dataset.family;
        onClick(family);
    }

    let className = `box ${styles.productBox}`;
    if (selected && !fullSizedBox) {
        className += ' ' + styles.selected;
    }
    if (fullSizedBox) {
        className += ' ' + styles.suiteBox;
    }
    if (isAlt){
        className += ' ' + styles.altBox;
    }

    let bullets: React.JSX.Element[] = []
    product.features.forEach((f: PricingFeature, i: number) => {
        if (typeof f === 'string') {
            bullets.push(<li key={i}>{t(keyPrefix + 'features.' + i)}</li>)
            return;
        }
        const subBullets = f.sub.map((_, j) => (
            <li key={j}>{t(keyPrefix + 'features.' + i + '.sub.' + j)}</li>
        ));
        bullets.push((
            <li key={i}>
                {t(keyPrefix + 'features.' + i + '.label')}
                <ul>{subBullets}</ul>
            </li>
        ))
    })

    const isSuite = product.slug == 'boris-fx-suite';

    return (
        <div className={className} data-family={product.title} onClick={handleClick}>
            {!fullSizedBox && (
            <div className={styles.productBoxBadge}>
                {isSuite && (
                    <div className={styles.bestValueContainer}>
                        <div className={styles.bestValue}>{t('bestValue')}</div>
                    </div>
                )}
            </div>
            )}
            <div className={styles.productBoxLogo}>
                <img src={product.logoUrl} />
            </div>
            
            <h4 className={styles.productBoxTitle}>{product.title}</h4>
            <div className={styles.productBoxText}>
                <p>{t(keyPrefix + 'subtitle')}</p>
                
                <h6 className={styles.productBoxListHeader}>{t('whatGet')}:</h6>
                <ul className={styles.productBoxFeatureList}>
                    {bullets}
                </ul>
            </div>
        </div>
    )
}